import { ECurrency as DBECurrency } from '@pushflow/database/prisma/types/enums'

export const ECurrency = DBECurrency
export type ECurrency = (typeof DBECurrency)[keyof typeof DBECurrency]
